function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import _Modal from "antd/es/modal";
var _excluded = ["className", "type", "visible", "width", "size", "height", "bodyStyle", "handle", "children", "footer", "okButtonProps", "disabled", "confirmLoading", "title", "okText", "cancelText", "onOk", "onCancel", "onVisibleChange"],
  _excluded2 = ["okText", "className", "cancelText", "cancelabel", "okButtonProps", "wrapClassName"],
  _excluded3 = ["icon", "cancelabel"],
  _excluded4 = ["icon", "okButtonProps", "okText", "cancelabel"],
  _excluded5 = ["icon", "okButtonProps", "okText"],
  _excluded6 = ["icon", "okButtonProps", "okText"],
  _excluded7 = ["icon", "okButtonProps", "okText"],
  _excluded8 = ["icon", "okButtonProps", "okText"];
var _this = this;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useMemo, useEffect } from 'react';
import SLSymbolIcon from '../OneSymbolIcon';
import { OneButton, OneSecondaryButton } from '../OneButton';
import classnames from 'classnames';
import { i18n } from '../_utils/language';
import './index.less';
var sizes = /*#__PURE__*/function (sizes) {
  sizes[sizes["extraSmall"] = 300] = "extraSmall";
  sizes[sizes["small"] = 480] = "small";
  sizes[sizes["middle"] = 620] = "middle";
  sizes[sizes["large"] = 860] = "large";
  return sizes;
}(sizes || {}); // 大弹窗
var DEFAULTMINHEIGHT = '120px'; // 默认最小高度
var DEFAULTTYPE = 'normal'; // 默认类型
var DEFAULTSIZE = 'middle'; // 默认宽度
var SMALLSIZE = 'small'; // 最小宽度
var SMALLSIZETYPE = ['confirm', 'info', 'warn']; // 最小尺寸的type

var OneModal = function OneModal(props) {
  var className = props.className,
    _props$type = props.type,
    type = _props$type === void 0 ? DEFAULTTYPE : _props$type,
    visible = props.visible,
    width = props.width,
    _props$size = props.size,
    size = _props$size === void 0 ? SMALLSIZETYPE.includes(props.type || DEFAULTTYPE) ? SMALLSIZE : DEFAULTSIZE : _props$size,
    _props$height = props.height,
    height = _props$height === void 0 ? 'initial' : _props$height,
    bodyStyle = props.bodyStyle,
    handle = props.handle,
    children = props.children,
    footer = props.footer,
    okButtonProps = props.okButtonProps,
    disabled = props.disabled,
    confirmLoading = props.confirmLoading,
    title = props.title,
    okText = props.okText,
    cancelText = props.cancelText,
    onOk = props.onOk,
    onCancel = props.onCancel,
    onVisibleChange = props.onVisibleChange,
    rest = _objectWithoutProperties(props, _excluded);

  // i18n
  var t = i18n;
  var _useState = useState(visible),
    _useState2 = _slicedToArray(_useState, 2),
    visibleStatus = _useState2[0],
    setVisibleStatus = _useState2[1]; // 控制弹窗显示隐藏
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    innerLoader = _useState4[0],
    setInnerLoader = _useState4[1]; // 内部控制按钮加载动画

  useEffect(function () {
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(visibleStatus);
  }, [onVisibleChange, visibleStatus]);

  // 更新状态
  useMemo(function () {
    setVisibleStatus(visible);
  }, [visible]);

  /**
   * 关闭
   */
  var hideModal = function hideModal() {
    setVisibleStatus(false);
  };

  /**
   * 显示
   */
  var showModal = function showModal() {
    if (!visibleStatus) {
      setVisibleStatus(true);
    }
  };

  /**
   * 确认按钮
   * @param e
   */
  var onConfirm = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!visibleStatus) {
              _context.next = 16;
              break;
            }
            if (!handle) {
              _context.next = 15;
              break;
            }
            setInnerLoader(true);
            _context.prev = 3;
            _context.next = 6;
            return onOk === null || onOk === void 0 ? void 0 : onOk.call(_this, e);
          case 6:
            result = _context.sent;
            if (result !== false) {
              hideModal();
            }
            _context.next = 12;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
          case 12:
            setInnerLoader(false);
            _context.next = 16;
            break;
          case 15:
            onOk === null || onOk === void 0 ? void 0 : onOk.call(_this, e);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function onConfirm(_x2) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * 取消按钮
   * @param e
   */
  var onClose = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var result;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!visibleStatus) {
              _context2.next = 14;
              break;
            }
            if (!handle) {
              _context2.next = 13;
              break;
            }
            _context2.prev = 2;
            _context2.next = 5;
            return onCancel === null || onCancel === void 0 ? void 0 : onCancel.call(_this, e);
          case 5:
            result = _context2.sent;
            if (result !== false) {
              hideModal();
            }
            _context2.next = 11;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
          case 11:
            _context2.next = 14;
            break;
          case 13:
            onCancel === null || onCancel === void 0 ? void 0 : onCancel.call(_this, e);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 9]]);
    }));
    return function onClose(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var footerNode = function footerNode() {
    if (footer === null || footer === false || typeof footer === 'string' || typeof footer === 'number' || footer instanceof Array || /*#__PURE__*/React.isValidElement(footer)) {
      return footer;
    }
    var f = footer;
    return /*#__PURE__*/React.createElement("div", {
      className: 'one-modal-footer'
    }, /*#__PURE__*/React.createElement("div", null, f === null || f === void 0 ? void 0 : f.left), /*#__PURE__*/React.createElement("div", null, (f === null || f === void 0 ? void 0 : f.right) ? f === null || f === void 0 ? void 0 : f.right : /*#__PURE__*/React.createElement(React.Fragment, null, type !== 'info' && /*#__PURE__*/React.createElement(OneSecondaryButton, {
      onClick: onClose
    }, cancelText || t('SLModal.default.cacelText')), /*#__PURE__*/React.createElement(OneButton, _extends({
      type: "primary",
      danger: type === 'warn',
      disabled: disabled,
      loading: innerLoader || confirmLoading
    }, okButtonProps, {
      onClick: disabled || innerLoader || confirmLoading ? undefined : onConfirm
    }), okText || t('SLModal.default.okText')))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, handle && /*#__PURE__*/React.createElement("span", {
    onClick: showModal
  }, handle), /*#__PURE__*/React.createElement(_Modal, _extends({
    className: classnames('one-modal', className, title === false ? 'one-modal-noHeader' : ''),
    width: width || sizes[size],
    title: title,
    visible: visibleStatus,
    bodyStyle: _objectSpread({
      minHeight: DEFAULTMINHEIGHT,
      height: height,
      overflowY: 'auto'
    }, bodyStyle),
    onOk: onConfirm,
    onCancel: onClose,
    closeIcon: /*#__PURE__*/React.createElement(SLSymbolIcon, {
      icon: "icon-Cross",
      style: {
        fontSize: 24,
        color: '#474F5E'
      }
    }),
    centered: true
  }, rest, {
    footer: footerNode()
  }), children));
};

/**
 * 为dialog方法新增属性
 */

/**
 * Dialog
 */
export var Dialog = function Dialog(_ref3) {
  var okText = _ref3.okText,
    className = _ref3.className,
    cancelText = _ref3.cancelText,
    _ref3$cancelabel = _ref3.cancelabel,
    cancelabel = _ref3$cancelabel === void 0 ? false : _ref3$cancelabel,
    _ref3$okButtonProps = _ref3.okButtonProps,
    okButtonProps = _ref3$okButtonProps === void 0 ? {} : _ref3$okButtonProps,
    wrapClassName = _ref3.wrapClassName,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  // i18n
  var t = i18n;
  return _Modal.confirm(_objectSpread({
    className: classnames('one-modal-confirm', className),
    wrapClassName: classnames('ant-modal-centered', wrapClassName),
    okText: okText || t('SLModal.default.okText'),
    cancelText: cancelText || t('SLModal.default.cacelText'),
    cancelButtonProps: {
      style: cancelabel === true ? {} : {
        display: 'none'
      },
      className: 'one-btn-secondary one-btn'
    },
    okButtonProps: _objectSpread(_objectSpread({
      type: 'primary'
    }, okButtonProps), {}, {
      className: classnames('one-btn', okButtonProps.className)
    }),
    autoFocusButton: null
  }, rest));
};

/**
 * 确认
 */
export var Confirm = function Confirm(_ref4) {
  var _ref4$icon = _ref4.icon,
    icon = _ref4$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
      className: "anticon one-confirm-modal-circle-icon",
      icon: "icon-iconinfo-circle"
    }) : _ref4$icon,
    _ref4$cancelabel = _ref4.cancelabel,
    cancelabel = _ref4$cancelabel === void 0 ? true : _ref4$cancelabel,
    rest = _objectWithoutProperties(_ref4, _excluded3);
  return Dialog(_objectSpread({
    icon: icon,
    cancelabel: cancelabel
  }, rest));
};

/**
 * 危险操作确认弹窗
 */
export var Danger = function Danger(props) {
  var _props$icon = props.icon,
    icon = _props$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
      className: "anticon one-danger-modal-circle-icon",
      icon: "icon-iconExclamationCircle"
    }) : _props$icon,
    okButtonProps = props.okButtonProps,
    okText = props.okText,
    _props$cancelabel = props.cancelabel,
    cancelabel = _props$cancelabel === void 0 ? true : _props$cancelabel,
    rest = _objectWithoutProperties(props, _excluded4);
  // i18n
  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    cancelabel: cancelabel,
    okButtonProps: _objectSpread({
      danger: true
    }, okButtonProps),
    okText: okText || t('SLModal.danger.okText')
  }, rest));
};

/**
 * 成功
 */
export var Success = function Success(_ref5) {
  var _ref5$icon = _ref5.icon,
    icon = _ref5$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
      className: "anticon one-success-modal-circle-icon",
      icon: "icon-iconCheckCircle"
    }) : _ref5$icon,
    okButtonProps = _ref5.okButtonProps,
    okText = _ref5.okText,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  // i18n
  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    okText: okText || t('SLModal.info.okText'),
    okButtonProps: _objectSpread({
      type: 'default',
      className: 'one-btn-secondary one-btn'
    }, okButtonProps)
  }, rest));
};

/**
 * 信息
 */
export var Info = function Info(_ref6) {
  var _ref6$icon = _ref6.icon,
    icon = _ref6$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
      style: {
        color: '#4B88FF'
      },
      className: "anticon",
      icon: "icon-iconinfo-circle"
    }) : _ref6$icon,
    okButtonProps = _ref6.okButtonProps,
    okText = _ref6.okText,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  // i18n
  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    okText: okText || t('SLModal.info.okText'),
    okButtonProps: _objectSpread({
      type: 'default',
      className: 'one-btn-secondary one-btn'
    }, okButtonProps)
  }, rest));
};

/**
 * 警告
 */
export var Warn = function Warn(_ref7) {
  var _ref7$icon = _ref7.icon,
    icon = _ref7$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
      className: "anticon one-warning-modal-circle-icon ",
      icon: "icon-iconExclamationCircle"
    }) : _ref7$icon,
    okButtonProps = _ref7.okButtonProps,
    okText = _ref7.okText,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  // i18n
  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    okText: okText || t('SLModal.info.okText'),
    okButtonProps: _objectSpread({
      type: 'default',
      className: 'one-btn-secondary one-btn'
    }, okButtonProps)
  }, rest));
};

/**
 * 错误
 */
var _Error = function _Error(_ref8) {
  var _ref8$icon = _ref8.icon,
    icon = _ref8$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
      className: "anticon one-error-modal-circle-icon",
      icon: "icon-iconCloseCircle"
    }) : _ref8$icon,
    okButtonProps = _ref8.okButtonProps,
    okText = _ref8.okText,
    rest = _objectWithoutProperties(_ref8, _excluded8);
  // i18n
  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    okText: okText || t('SLModal.info.okText'),
    okButtonProps: _objectSpread({
      type: 'default',
      className: 'one-btn-secondary one-btn'
    }, okButtonProps)
  }, rest));
};
export { _Error as Error };
OneModal.confirm = Confirm;
OneModal.danger = Danger;
OneModal.success = Success;
OneModal.info = Info;
OneModal.warn = Warn;
OneModal.error = _Error;
export default OneModal;